var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section columns is-hidden-mobile"},_vm._l((_vm.frequentItems),function(frequentItem){return _c('FrequentItem',{key:frequentItem.name,attrs:{"frequentItem":frequentItem}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }